export enum OrganizationType {
  pl5 = '5pl',
  pl4 = '4pl',
  pl3 = '3pl',
  pl2 = '2pl',
  pl1 = '1pl',
  fleetOwner = 'fleetOwner',
}
